import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

export const defaultHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  let oauth = inject(OAuthService);

  if( req.url.includes('/api/')) {
    console.log('Applying default headers for API request');
          let headers = req.headers;
      headers = headers.set('Authorization', `Bearer ${ oauth.getAccessToken()} `);
      headers = headers.set('X-Active-Client', sessionStorage.getItem('activeClient') || '');
      let modifiedRequest = req.clone({ headers });
      return next(modifiedRequest);
  }

  return next(req);
};
